import { BusinessGroup } from 'components/search/utils';
import { toLower } from 'es-toolkit/compat';

export const businessGroups: BusinessGroup[] = [
  {
    id: 5592,
    name: 'Big Red F',
    slug: 'big-red-f',
  },
  {
    id: 1833,
    name: 'Burger & Lobster',
    slug: 'burger-lobster',
  },
  {
    id: 4617,
    name: 'Keystone Resort',
    slug: 'keystone-resort',
  },
  {
    id: 40,
    name: 'Lettuce Entertain You',
    slug: 'lettuce-entertain-you',
  },
  {
    id: 6329,
    name: 'One Off Hospitality',
    slug: 'one-off-hospitality',
  },
  {
    id: 2,
    name: 'The Alinea Group',
    slug: 'the-alinea-group',
  },
  {
    id: 478,
    name: 'Thomas Keller Group',
    slug: 'tkg',
  },
  {
    id: 2521,
    name: 'Bread & Butter Concepts',
    slug: 'bread-n-butter',
  },
  {
    id: 1829,
    name: 'Boka Group',
    slug: 'boka-group',
  },
  {
    id: 6020,
    name: 'Telluride',
    slug: 'telluride-ski-resort',
  },
  {
    id: 4573,
    name: 'Bartolotta Restaurants',
    slug: 'bartolotta-restaurants',
  },
  {
    id: 2223,
    name: 'Wagyumafia',
    slug: 'wagyumafia',
  },
  {
    id: 6633,
    name: 'Big Night Restaurant Group ',
    slug: 'big-night-restaurant-group',
  },
  {
    id: 7025,
    name: 'Hard Rock Cafe',
    slug: 'hard-rock-cafe',
  },
  {
    id: 9840,
    name: 'Grill Concepts',
    slug: 'grill-concepts',
  },
  {
    id: 7305,
    name: 'Foley Family Wines',
    slug: 'foley-family-wines',
  },
  {
    id: 10918,
    name: 'Tao Group',
    slug: 'tao-group',
  },
  {
    id: 13200,
    name: 'Wells Street Market',
    slug: 'wells-street-market',
  },
  {
    id: 11616,
    name: 'Tin Roof Bars',
    slug: 'tin-roof-bars',
  },
  {
    id: 775,
    name: 'Treasury Wine Estates',
    slug: 'treasury-wine-estates',
  },
  {
    id: 8233,
    name: 'Michelin Experiences/Samsung Galaxy Z',
    slug: 'michelin-experiences-samsung',
  },
  {
    id: 13747,
    name: 'Donnelly Group',
    slug: 'donnelly-group',
  },
  {
    id: 14712,
    name: "Let's Talk Chicago Women",
    slug: 'letstalkchicagowomen',
  },
  {
    id: 14916,
    name: 'Wilmot Mountain',
    slug: 'wilmot-mountain',
  },
  {
    id: 14911,
    name: 'Whistler Blackcomb',
    slug: 'whistler-blackcomb',
  },
  {
    id: 14910,
    name: 'Vail Ski Resort',
    slug: 'vail',
  },
  {
    id: 14909,
    name: 'Stowe Mountain Resort',
    slug: 'stowe-mountain',
  },
  {
    id: 14907,
    name: 'Roundtop Mountain Resort',
    slug: 'roundtop-mountain',
  },
  {
    id: 14906,
    name: 'Park City Mountain',
    slug: 'park-city-mountain',
  },
  {
    id: 14902,
    name: 'Northstar California Resort',
    slug: 'northstar-california',
  },
  {
    id: 14901,
    name: 'Mount Snow Resort',
    slug: 'mount-snow',
  },
  {
    id: 6267,
    name: 'Liberty Mountain Resort',
    slug: 'liberty-mountain',
  },
  {
    id: 14898,
    name: 'Hunter Mountain Resort',
    slug: 'hunter-mountain',
  },
  {
    id: 14897,
    name: 'Heavenly Ski Resort',
    slug: 'heavenly',
  },
  {
    id: 14892,
    name: 'Afton Alps Resort',
    slug: 'afton-alps',
  },
  {
    id: 15223,
    name: 'Crested Butte Mountain Resort',
    slug: 'crested-butte-mountain',
  },
  {
    id: 14896,
    name: 'Breckenridge Ski Resort',
    slug: 'breckenridge',
  },
  {
    id: 14894,
    name: 'Beaver Creek Resort',
    slug: 'beaver-creek',
  },
  {
    id: 10009,
    name: "Clyde's Restaurant Group",
    slug: 'clydes',
  },
  {
    id: 15102,
    name: 'Sugarbush Resort',
    slug: 'sugarbush',
  },
  {
    id: 11272,
    name: 'Doughboy Restaurant Group',
    slug: 'doughboyrestaurantgroup',
  },
  {
    id: 16325,
    name: 'Jean-Georges Restaurants',
    slug: 'jean-georgesrestaurants',
  },
  {
    id: 14903,
    name: 'Okemo',
    slug: 'okemo',
  },
  {
    id: 11920,
    name: 'The Fish Market',
    slug: 'thefishmarket',
  },
  {
    id: 212,
    name: 'ThinkFoodGroup',
    slug: 'thinkfoodgroup',
  },
  {
    id: 16774,
    name: 'Deja Food Group',
    slug: 'dejafoodgroup',
  },
  {
    id: 7219,
    name: 'Mina Group',
    slug: 'minagroup',
  },
  {
    id: 17548,
    name: 'The Gallivant',
    slug: 'thegallivant',
  },
  {
    id: 15614,
    name: "Francesca's Restaurant Group",
    slug: 'francescasrestaurantgroup',
  },
  {
    id: 8213,
    name: 'Best Restaurant Group',
    slug: 'bestrestaurantgroup',
  },
  {
    id: 18369,
    name: 'Elevage Hospitality',
    slug: 'elevagehospitality',
  },
  {
    id: 6754,
    name: 'Viaggio Hospitality',
    slug: 'viaggiohospitality',
  },
  {
    id: 17683,
    name: 'E&J Gallo',
    slug: 'ejgallo',
  },
  {
    id: 10277,
    name: 'Victory Restaurant Group',
    slug: 'victoryrestaurantgroup',
  },
  {
    id: 19046,
    name: 'Chicago Blackhawks',
    slug: 'chicagoblackhawks',
  },
  {
    id: 19222,
    name: 'Attitash',
    slug: 'attitash',
  },
  {
    id: 19407,
    name: 'Big Boulder Mountain',
    slug: 'big-boulder-mountain',
  },
  {
    id: 19409,
    name: 'Jack Frost Mountain',
    slug: 'jack-frost-mountain',
  },
  {
    id: 17940,
    name: 'Kirkwood Resort',
    slug: 'kirkwood-resort',
  },
  {
    id: 19410,
    name: 'Mad River Mountain',
    slug: 'mad-river-mountain',
  },
  {
    id: 19412,
    name: 'Mt Crotched',
    slug: 'mt-crotched',
  },
  {
    id: 19218,
    name: 'Mt. Brighton',
    slug: 'mt-brighton',
  },
  {
    id: 19219,
    name: 'Mt. Sunapee',
    slug: 'mt-sunapee',
  },
  {
    id: 19411,
    name: 'Snow Creek Mountain',
    slug: 'snow-creek-mountain',
  },
  {
    id: 15487,
    name: 'Stevens Pass',
    slug: 'stevens-pass',
  },
  {
    id: 19220,
    name: 'Whitetail',
    slug: 'whitetail',
  },
  {
    id: 19223,
    name: 'Wildcat',
    slug: 'wildcat',
  },
  {
    id: 19597,
    name: 'Newport Dine Out',
    slug: 'newport-dine-out',
  },
  {
    id: 19704,
    name: 'Hidden Valley',
    slug: 'hidden-valley',
  },
  {
    id: 13347,
    name: '4 Star Restaurant Group',
    slug: '4-star-restaurant-group',
  },
  {
    id: 2644,
    name: 'Yardbird - Thanksgiving To-Go',
    slug: 'yardbirdtogo',
  },
  {
    id: 20180,
    name: "McAlister's Deli",
    slug: 'mcalistersdeli',
  },
  {
    id: 5718,
    name: 'J. Rieger & Co.',
    slug: 'j-rieger-co-kansas-city',
  },
  {
    id: 20709,
    name: 'Six by Nico',
    slug: 'sixbynico',
  },
  {
    id: 5817,
    name: 'Patina Restaurant Group',
    slug: 'patina-restaurant-group',
  },
  {
    id: 17715,
    name: 'Bravo Restaurants',
    slug: 'bravo-restaurants',
  },
  {
    id: 22121,
    name: 'Big Onion Hospitality',
    slug: 'big-onion-hospitality',
  },
  {
    id: 6965,
    name: 'Fabio Trabocchi',
    slug: 'fabio-trabocchi',
  },
  {
    id: 17276,
    name: 'SE Productions',
    slug: 'seproductions',
  },
  {
    id: 20836,
    name: 'Hyatt Regency Chesapeake Bay',
    slug: 'hyatt-regency-chesapeake-bay',
  },
  {
    id: 14328,
    name: 'Hotel Kansas City',
    slug: 'hotel-kansas-city',
  },
  {
    id: 20639,
    name: 'Hyatt Regency Huntington Beach',
    slug: 'hyatt-regency-huntington-beach',
  },
  {
    id: 20371,
    name: 'Hyatt Regency Lake Tahoe',
    slug: 'hyatt-regency-lake-tahoe',
  },
  {
    id: 20655,
    name: 'Hyatt Regency Lost Pines',
    slug: 'hyatt-regency-lost-pines',
  },
  {
    id: 20977,
    name: 'Park Hyatt St. Kitts',
    slug: 'park-hyatt-st-kitts',
  },
  {
    id: 18455,
    name: 'Park Hyatt Toronto',
    slug: 'park-hyatt-toronto',
  },
  {
    id: 22946,
    name: 'Taste Club',
    slug: 'taste-club',
  },
  {
    id: 22719,
    name: 'Aspen Snowmass',
    slug: 'aspen-snowmass',
  },
  {
    id: 23319,
    name: 'American Red Cross',
    slug: 'american-red-cross',
  },
  {
    id: 5787,
    name: 'Creative Food Group',
    slug: 'cfg',
  },
  {
    id: 23263,
    name: 'Upstairs Circus Group',
    slug: 'upstairs-circus-group',
  },
  {
    id: 23785,
    name: 'Taste Washington',
    slug: 'taste-washington',
  },
  {
    id: 6249,
    name: 'Craft and Crew',
    slug: 'craft-crew',
  },
  {
    id: 23487,
    name: 'Ryan Patrick Wines + Milbrandt Vineyards',
    slug: 'ryan-patrick-wines-milbrandt-vineyards',
  },
  {
    id: 24056,
    name: 'Avenida Brazil Churrascaria Steakhouse',
    slug: 'avenida-brazil-churrascaria-steakhouse',
  },
  {
    id: 22147,
    name: 'FAR Out Hospitality',
    slug: 'far-out-hospitality',
  },
  {
    id: 15314,
    name: 'Boisset Collection',
    slug: 'boisset-collection',
  },
  {
    id: 24254,
    name: 'Kinka Izakaya',
    slug: 'kinka-izakaya',
  },
  {
    id: 280,
    name: 'Strategic Hospitality',
    slug: 'strategic-hospitality',
  },
  {
    id: 22541,
    name: 'Precept Wine',
    slug: 'precept-wine',
  },
  {
    id: 24776,
    name: 'LEGO® Play Stadium Tour',
    slug: 'lego-play-stadium-tour',
  },
  {
    id: 24543,
    name: 'Pago Restaurant Group',
    slug: 'pago-restaurant-group',
  },
  {
    id: 19016,
    name: 'Grand Geneva Resort & Spa',
    slug: 'grand-geneva-resort',
  },
  {
    id: 21422,
    name: 'The Ginger Brands',
    slug: 'the-ginger-brands',
  },
  {
    id: 11354,
    name: 'Winston Pies',
    slug: 'winston-pies',
  },
  {
    id: 15333,
    name: 'Kitchen Table',
    slug: 'kitchen-table',
  },
  {
    id: 15526,
    name: 'Food Fight Restaurant Group',
    slug: 'food-fight-restaurant-group',
  },
  {
    id: 22938,
    name: 'Deer Valley Resort',
    slug: 'deer-valley-resort-group',
  },
  {
    id: 4239,
    name: 'Far Niente Wine Estates',
    slug: 'far-niente-wine-estates',
  },
  // These are for demo only.
  {
    id: 6375,
    name: 'Chicago Blackhawks',
    slug: 'chicagoblackhawks',
  },
  {
    id: 7150,
    name: 'Vail Resorts F&B Outlets',
    slug: 'vail-resorts-fb-outlets',
  },
  {
    id: 9833,
    name: 'Soho House Chicago',
    slug: 'soho-house-chicago',
  },
];

export const findBusinessGroup = (urlParam: string) => {
  return businessGroups.find((m) => toLower(m.slug) === toLower(urlParam));
};
